export default __webpack_public_path__ + "dc3108747a.woff";